
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import Footer from "@/pages/LandingPage/Footer";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PageLayoutProps {
  children: ReactNode;
  showBackButton?: boolean;
  pageTitle?: string;
}

const PageLayout = ({ 
  children, 
  showBackButton = true,
  pageTitle = "cheqbooq"
}: PageLayoutProps) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header - using semantic header tag for SEO */}
      <header className="border-b border-border/20 backdrop-blur-lg bg-background/80 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto flex justify-between items-center py-5 px-6">
          <Link to="/" className="text-2xl font-display font-medium text-foreground tracking-tight" aria-label="Navigate to homepage">
            {pageTitle}
          </Link>
          {showBackButton && (
            <Link to="/">
              <Button variant="outline" className="flex items-center gap-2" aria-label="Go back to home page">
                <ArrowLeft className="h-4 w-4" />
                Back to Home
              </Button>
            </Link>
          )}
        </div>
      </header>
      
      {/* Content - using semantic main tag for SEO */}
      <main>
        {children}
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PageLayout;
